import styled from 'styled-components';
import * as ReactTabs from 'react-tabs';

export const Tabs = styled(ReactTabs.Tabs).attrs({
  selectedTabClassName: 'selected',
  selectedTabPanelClassName: 'selected',
})`
  display: flex;
  width: 100%;
  height: 100%;
  ${({ isHorizontal }) =>
    isHorizontal &&
    `
    flex-direction: column;
  `}
`;

export const TabList = styled(ReactTabs.TabList)`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding-left: ${({ theme }) => theme.spacing.m};
  padding-right: ${({ theme }) => theme.spacing.m};
  margin: 0;
  border-right: 1px solid #ddd;
  width: 260px;
  ${({ isHorizontal, theme }) =>
    isHorizontal &&
    `
    align-items: flex-start;
    flex-direction: row;
    border: none;
    margin-bottom: ${theme.spacing.l};
  `}
`;

export const Tab = styled(ReactTabs.Tab)`
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.04em;
  text-align: left;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.selected {
    background-color: ${({ theme }) => theme.colors.quaternary};
    font-weight: bold;
  }

  &:focus {
    outline: none;
  }
`;

export const TabPanel = styled(ReactTabs.TabPanel)`
  flex-grow: 1;
  display: none;
  padding-left: ${({ theme }) => theme.spacing.m};
  padding-right: ${({ theme }) => theme.spacing.m};
  ${({ isHorizontal }) =>
    isHorizontal &&
    `
    padding: 0;
  `}
  &.selected {
    display: block;
  }
`;
